export const TEST_ID = {
  APP_REQUEST_BTN: 'request-app__request-app-btn',
  APP_REQUEST_MODAL_CLOSE_BTN: 'request-app__close-modal-btn',
  APP_REQUEST_MODAL_SUBMIT_BTN: 'request-app-modal__submit-request-btn'
};
export const INSTALLED_STATE_CONTENT = 'This app is already installed on your instance.';
export const REJECTED_STATUS_CONTENT = 'Your app request was rejected since';
export const REQUESTED_STATE_CONTENT = 'Your app request is currently under review. Please reach out to your site admin for more details';